<script setup lang="ts">
import { toRefs } from "vue";
import { RouterLink } from "vue-router";
import { utc2local } from "@/utils";
import type { User } from "@/rvapi";

const props = defineProps<{
  users: User[];
  searching: boolean;
}>();

const { users, searching } = toRefs(props);
</script>

<template>
  <section v-show="!searching && users.length > 0">
    <h3>Users</h3>
    <pn-table bordered="true" striped="true">
      <table>
        <thead>
          <tr>
            <th>User</th>
            <th>Email</th>
            <th>Newsletter</th>
            <th>Latest login</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.userId">
            <td>
              <RouterLink v-show="user.userId" :to="'/user/' + user.userId">{{
                user.userId
              }}</RouterLink>
            </td>
            <td>{{ user.email }}</td>
            <td>{{ user.signedUpForNewsletter ? "Yes" : "" }}</td>
            <td>{{ utc2local(user.lastLoginAt) }}</td>
          </tr>
        </tbody>
      </table>
    </pn-table>
  </section>
</template>
<style lang="scss" scoped></style>
